import React, { Component } from "react";

import "./Loading.css";
class Loading extends Component {
  render() {
    return (
      <div className="ladingScreen">
        <h2>Adatok betöltése...</h2>
      </div>
    );
  }
}
export default Loading;
